var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 162 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_profile_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.957-1.875c17.192 0 35.425 14.481 35.425 25.29v25.3c0 9.737-4.05 28.367-14.912 36.92a10.125 10.125 0 00-3.792 9.146 10.123 10.123 0 005.83 8.009l44.059 20.893c.344.157 4.222.807 4.222 6.224l.005 9.882-141.67.008v-10.274c0-4.025 3.02-5.288 4.228-5.845l44.459-20.982a10.116 10.116 0 005.817-7.96c.43-3.481-.975-6.936-3.711-9.13C50.4 77.16 45.499 58.598 45.499 48.714v-25.3c.002-10.576 18.417-25.29 35.458-25.29zm0-10.125C58.6-12 35.374 6.658 35.374 23.415v25.3c0 11.054 5.045 33.42 19.205 44.785l-44.462 20.984S0 118.992 0 124.604v15.193c0 5.591 4.531 10.12 10.117 10.12h141.679c5.592 0 10.12-4.529 10.12-10.12v-15.193c0-5.948-10.12-10.12-10.12-10.12l-44.059-20.893c14.026-11.038 18.772-32.724 18.772-44.876v-25.3C126.509 6.658 103.31-12 80.957-12z",
    fill: "#1F2123"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_profile_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 -12)",
    d: "M0 0h162v162H0z"
  })))));
}
export default SvgIcProfile;